import React from 'react'

import { supportedLanguages } from '@common'
import { IntlMessageFormat } from 'intl-messageformat'

import { useLocale } from '@/features/locale/useLocale'

import { NoWrap } from './globalFormats'

function addKeyAttributesIfNeeded(values: string | JSX.Element | (string | JSX.Element | undefined)[] | undefined) {
  if (Array.isArray(values)) {
    return values.map((element, i) => {
      if (React.isValidElement(element)) {
        return React.cloneElement(element, { key: i })
      }
      return element
    })
  }
  return values
}

export const useIntlMessageFormat = () => {
  const locale = useLocale()
  return (message?: string) => {
    if (!message) return ''
    try {
      const formatter = new IntlMessageFormat(message, supportedLanguages[locale].locale)
      return addKeyAttributesIfNeeded(
        formatter.format({
          NoWrap,
        }),
      )
    } catch (err) {
      return ''
    }
  }
}
